export default { /** 页面进入时  加载提示层的显示隐藏 */
  namespaced: true,
  state: {
    show: false, /** 开启关闭 */
  },
  getters: {

  },
  mutations: {
    show(state, status) {
      if (status) {
        state.show = true;
      } else {
        state.show = false;
      }
    },
  },
  actions: {
    showGo(content, status) {
      content.commit('show', status);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/load.js